import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface SearchActiveDirectoryUserNameParams {
  name: string;
}

export interface User {
  username: string;
  displayName: string;
  upn: string;
}

export interface SearchActiveDirectoryUserNameResult extends IResult {
  users: User[];
  hasMoreItems: boolean;
}

export class SearchActiveDirectoryUserNameRequest extends Request<SearchActiveDirectoryUserNameParams, SearchActiveDirectoryUserNameResult> {
  constructor(params: SearchActiveDirectoryUserNameParams) {
    super('searchActiveDirectoryUserName', params);
  }
}
